/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceNotificationResponse
 */
export interface ServiceNotificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceNotificationResponse
     */
    isEnabled?: boolean;
}

export function ServiceNotificationResponseFromJSON(json: any): ServiceNotificationResponse {
    return ServiceNotificationResponseFromJSONTyped(json, false);
}

export function ServiceNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceNotificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}

export function ServiceNotificationResponseToJSON(value?: ServiceNotificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isEnabled': value.isEnabled,
    };
}

